var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search_btn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Sales-Targets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-3-Geo_County",
    transform: "translate(-410.000000, -224.000000)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(403.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_btn",
    transform: "translate(6.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(11.124060, 10.500000) scale(-1, 1) translate(-11.124060, -10.500000) translate(0.624060, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7891261,14.2025991 C9.25710311,14.2025991 6.39382166,11.3716087 6.39382166,7.8794187 C6.39382166,4.38869474 9.25710311,1.55770441 12.7891261,1.55770441 C16.3211491,1.55770441 19.1844306,4.38869474 19.1844306,7.8794187 C19.1844306,11.3716087 16.3211491,14.2025991 12.7891261,14.2025991 L12.7891261,14.2025991 Z M3.06642467,19.065569 C2.86031586,19.2766837 2.57561879,19.4100965 2.25681739,19.4100965 C1.63404255,19.4100965 1.12840869,18.9101651 1.12840869,18.2929476 C1.12840869,17.9792076 1.26334324,17.6977212 1.47538324,17.4939369 L1.46945206,17.4880726 L6.62810362,12.3890646 C7.07887398,12.9901552 7.61564658,13.5208743 8.22359344,13.9680271 L3.06642467,19.065569 Z M12.7891261,0.292481911 C8.55129163,0.292481911 5.11565045,3.69084316 5.11565045,7.8794187 C5.11565045,9.16076802 5.44038304,10.3658815 6.00681158,11.4258535 L0.671707146,16.6993243 L0.676155537,16.7037226 C0.259489515,17.1083592 3.01980663e-14,17.6713319 3.01980663e-14,18.2929476 C3.01980663e-14,19.5259164 1.00978491,20.5257794 2.25681739,20.5257794 C2.88700621,20.5257794 3.45491755,20.2677503 3.86416958,19.8557833 L3.86416958,19.8557833 L9.19779122,14.5823124 C10.2683708,15.1452851 11.4901957,15.4678216 12.7891261,15.4678216 C17.0269606,15.4678216 20.4626018,12.0694603 20.4626018,7.8794187 C20.4626018,3.69084316 17.0269606,0.292481911 12.7891261,0.292481911 L12.7891261,0.292481911 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.7891261,3.45436531 C10.3173031,3.45436531 8.31256128,5.43503228 8.31256128,7.88044495 C8.31256128,8.05490785 8.45639261,8.19565102 8.63284548,8.19565102 C8.80929835,8.19565102 8.95164688,8.05490785 8.95164688,7.88044495 C8.95164688,5.78542415 10.6702089,4.08624352 12.7891261,4.08624352 C12.965579,4.08624352 13.1094103,3.94550034 13.1094103,3.77103745 C13.1094103,3.59510848 12.965579,3.45436531 12.7891261,3.45436531",
    id: "Fill-4"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/search-grey.2bc09a0cc063b983d67b4939288170d7.svg";
export { ForwardRef as ReactComponent };